import React from 'react';
import classNames from 'classnames';

const DISPLAY_NAME = 'interaction-delete-modal';

export function InteractionDeleteModal() {
  return (
    <div
      className={classNames(DISPLAY_NAME)}
      data-testid="structured-interaction-delete-modal"
    >
      <p className="mb-4">
        If you delete this interaction it will no longer be visible for the client.
      </p>
      <p>
        Are you sure you want to delete?
      </p>
    </div>
  );
}
